import type { types } from '@bedc/types';

/** BEDC sends PII on purpose: most of its users are internal, and support needs it to troubleshoot. */
const bedc = {
	sendPii: true,
	sentry: { clientProject: 'platform-client', serverProject: 'platform-backend' },
	posthog: { apiHost: 'https://us.i.posthog.com' },
	// The router sends each pageview, so the tag must not send its own.
	googleAnalytics: { gtagOptions: { send_page_view: false } },
} satisfies types.telemetry.Profile;

/** Carters reports to its own Sentry org, and has no PostHog or GA destination yet. */
const carters = {
	sendPii: true,
	sentry: { clientProject: 'platform-client', serverProject: 'platform-backend' },
	posthog: null,
	googleAnalytics: null,
} satisfies types.telemetry.Profile;

/** The telemetry profile of every environment. */
export const profiles = {
	local: bedc,
	'local-staging': bedc,
	dev: bedc,
	test: bedc,
	prod: bedc,
	rome1234: bedc,
	'legacy-dev': bedc,
	'legacy-test': bedc,
	'legacy-prod': bedc,

	'carters-local-dev': carters,
	'carters-local-test': carters,
	'carters-dev': carters,
	'carters-test': carters,
	'carters-prod': carters,
} satisfies Record<types.environment.Environment, types.telemetry.Profile>;
